import { useQuery } from '@tanstack/react-query';
import { getUserStores, type StoresResponse } from '../api';

export function useStoresQuery(enabled = true) {
  return useQuery({
    queryKey: ['stores'],
    queryFn: async (): Promise<StoresResponse> => {
      return getUserStores();
    },
    enabled,
  });
}
